import { FieldConfiguration } from "./field-configuration";
import { ColumnSettings } from "./ui/column-settings";
import { TitleValue } from "./ui/title-value";

export class FormConfiguration {
  name: string;
  fieldConfigurations: FieldConfiguration[];
  isValid?: boolean;

  static applyToColumnSettings(formConfig: FormConfiguration, columnSettings: ColumnSettings[]): ColumnSettings[] {
    if (!formConfig || !formConfig.fieldConfigurations) {
      return columnSettings;
    }

    const updatedColumns = columnSettings
      .filter(cs => this.getFieldVisibility(formConfig, cs.field === 'SalesStatus' ? 'Status' : cs.field))
      .map(cs => {
        const fieldName = cs.field === 'SalesStatus' ? 'Status' : cs.field;
        const config = formConfig.fieldConfigurations.find(fc => fc.name === fieldName);
        return {
          ...cs,
          orderIndex: config?.order ?? 999
        };
      });

    if (formConfig.isValid) {
      return updatedColumns.sort((a, b) => a.orderIndex - b.orderIndex);
    }
    return updatedColumns;
  }

  static applyToTitleValues(formConfig: FormConfiguration, titleValues: TitleValue[]): TitleValue[] {
    return titleValues.filter(tv => tv.field == undefined || this.getFieldVisibility(formConfig, tv.field));
  }

  static getFieldVisibility(formConfig: FormConfiguration, fieldName: string): boolean {
    const adjustedFieldName = fieldName === 'SalesStatus' ? 'Status' : fieldName;
    const fieldConfig = formConfig.fieldConfigurations?.find(x => x.name === adjustedFieldName);
    return fieldConfig?.visible ?? true;
  }
}
